export function ContentSkeleton() {
  const shimmer = "bg-skeleton animate-[fv-shimmer_1.4s_ease-in-out_infinite]";

  return (
    <div class="font-theme">
      {/* Header — matches text-center px-6 pt-6 */}
      <div class="flex flex-col items-center gap-1.5 px-6 pt-6">
        <div class={`w-[260px] h-[25px] rounded-md ${shimmer}`} />
        <div class={`w-[320px] h-[18px] rounded-md ${shimmer} [animation-delay:0.05s]`} />
      </div>

      {/* Form body — matches px-6 pt-5 pb-6 gap-4 */}
      <div class="flex flex-col gap-4 px-6 pt-5 pb-6">
        {/* Field: label (20px) + gap-1 (4px) + input (42px) = 66px */}
        <div class="flex flex-col gap-1">
          <div class={`w-[140px] h-[20px] rounded ${shimmer} [animation-delay:0.1s]`} />
          <div class={`w-full h-[42px] rounded-theme ${shimmer} [animation-delay:0.15s]`} />
        </div>
        <div class="flex flex-col gap-1">
          <div class={`w-[130px] h-[20px] rounded ${shimmer} [animation-delay:0.2s]`} />
          <div class={`w-full h-[42px] rounded-theme ${shimmer} [animation-delay:0.25s]`} />
        </div>
        <div class="flex flex-col gap-1">
          <div class={`w-[180px] h-[20px] rounded ${shimmer} [animation-delay:0.3s]`} />
          <div class={`w-full h-[42px] rounded-theme ${shimmer} [animation-delay:0.35s]`} />
        </div>

        {/* Consent — checkbox + text block */}
        <div class="flex items-start gap-2.5 mt-1">
          <div class={`w-4 h-4 mt-0.5 shrink-0 rounded ${shimmer} [animation-delay:0.4s]`} />
          <div class="flex flex-col gap-1.5 flex-1">
            <div class={`w-full h-3 rounded ${shimmer} [animation-delay:0.4s]`} />
            <div class={`w-full h-3 rounded ${shimmer} [animation-delay:0.45s]`} />
            <div class={`w-full h-3 rounded ${shimmer} [animation-delay:0.45s]`} />
            <div class={`w-[80%] h-3 rounded ${shimmer} [animation-delay:0.5s]`} />
            <div class={`w-[60%] h-3 rounded ${shimmer} [animation-delay:0.5s]`} />
          </div>
        </div>

        {/* Submit button */}
        <div class={`w-full h-[48px] rounded-theme ${shimmer} [animation-delay:0.55s]`} />
      </div>

      {/* Powered by */}
      <div class="flex justify-center py-3">
        <div class={`w-[120px] h-[14px] rounded ${shimmer} [animation-delay:0.6s]`} />
      </div>
    </div>
  );
}
